<template>
    <div id="pdf-links" v-if="show">
      <div>
        <hp5-link-text-tertiary href="#" target="_blank" text="" v-if="shouldShowPrintDirectory">
          <a href="" v-on:click.prevent="onClick(300)">Download search results (PDF)</a>
        </hp5-link-text-tertiary>
      </div>
      <div id="internal-pdf-link" v-if="showInternal">
        <hp5-link-text-tertiary href="#" target="_blank">
          <a href="" v-on:click.prevent="onClick(1000)">Download 1,000 results - INTERNAL HP ONLY (PDF)</a>
        </hp5-link-text-tertiary>
      </div>
      <form name="pdfForm" target="_blank" :action="uri" method="post">
        <!-- Don't use networkId here, or confusingly you will get an array on the other side since the context has a networkId attribute that will
              be rendered below -->
        <input type="hidden" name="rc" :value="recordCount" />
        <input type="hidden" name="planNetworkId" :value="plan.networkId" />
        <input type="hidden" name="state" :value="state" />
        <input type="hidden" name="networkType" :value="plan.printTemplate" />
        <input type="hidden" name="planName" :value="plan.name" />
        <input type="hidden" name="tierLabel" :value="plan.tierLabel" />
        <input type="hidden" name="placeName" :value="searchCriteriaPlaceName" />
        <input type="hidden" name="language" :value="language" />
        <input type="hidden" name="employerGroupId" :value="employerGroupId" />
        <input type="hidden" name="pdfType" :value="pdfType" />
        <input type="hidden" name="count" :value="recordCount" />
        <input type="hidden" v-for="(value, propertyName) in context" :key="propertyName" :id="propertyName" :name="propertyName" :value="value" />
      </form>
    </div>
  </template>
  
  <script setup>
  /**
   * This component provides the functionality for displaying and executing the PDF download of search results.  One of the design
   * challenges was how to fire off a new tab with the results from the server.  Links ar a good way of doing that.  However, the
   * function needed here required the inclusiong of a lot of information that would need to be tagged on to the URL making the URL messy
   * and creating some less than enjoyable URL builder code to read that could also be buggy.  Instead, I decided to use a form and include
   * hidden fields for all the data items needed by the server.  On the server, the body will become the context of the PDF building code. Forms
   * all can be designated with a target which make them convenient for firing off in a new tab.  Normally post operations would be handled via
   * axios and returned with a JSON object, but in this case that is not appropriate as it will return a binary payload of 'application/pdf' that
   * needs to be handled directly by the browser.  The design choice was an attempt to balanced needed function with readability/maintanability.
   */

    const { context, profile, plan, searchCriteriaPlaceName, languages, isInternalUser, searchResults, groupNumber, env } = useFCPModel()
    const recordCount = ref(300)
    
    const show = computed(() => searchResults.value && searchResults.value.length > 0)    
    const shouldShowPrintDirectory = computed(() => profile.value.shouldShowPrintDirectory)
    
    // show 1000 results pdf link for internal HP users or when running locally
    const showInternal = computed(() => isInternalUser.value || env.value == 'local')
    
    const employerGroupId = computed(() => groupNumber.value)
    const language = computed(() => {
        if (languages.value && context.value.languageId) {
            const lang = languages.value.find((l) => parseInt(l.value) == context.value.languageId)
            return lang.label
        }

        return ''
    })
  
    //We need the state for looking up the online locations on the server.
    const state = computed(() => profile.value.state)
    const pdfType = computed(() => (context.value.type == 'doctor' || context.value.type == 'dentist') ? 'practitioner' : 'location')

      //Decide which PDF to load based upon the 'context.type' field and the recordCount chosen.
    //   const uri = computed(() => {
    //     let retVal = ''
    //     if (context.value.type == 'doctor' || context.value.type == 'dentist') retVal = `api/practitioner/${recordCount.value == 300 ? 'pdf' : 'pdf1k'}`
    //     else retVal = `api/location/${recordCount.value == 300 ? 'pdf' : 'pdf1k'}`
  
    //     if (context.value.networkId) retVal += `/?networkId=${context.value.networkId}`
  
    //     return retVal
    //   })
    
    const uri = computed(() => `api/pdf/?networkId=${context.value.networkId}`)
    
  
    const onClick = async (count) => {
        recordCount.value = count
        //Make sure that reactivity occurs before calling so that the URL is up to date before submitting the form.
        await nextTick()
        document.forms['pdfForm'].submit()
    }
  
</script>
  
<style scoped>
  #pdf-links {
    margin-top: var(--spacing-sm);
  }
</style>